<template>
    <div class="col-xs-12">
        <div class="width-0100 display-t border-b-1 border-solid border-color-b-010 margin-b-10">
            <div class="display-tc width-050 vertical-align-b padding-r-5 border-r-1 border-solid border-color-b-010">
                <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">12 hour accumulation</p>
                <p class="display-b color-b-0100 font-size-xxl text-align-r">{{ accumulation_12h }}"</p>
            </div>
            <div class="display-tc width-050 vertical-align-b padding-l-5">
                <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">24 hour accumulation</p>
                <p class="display-b color-b-0100 font-size-xxl text-align-r">{{ accumulation_24h }}"</p>
            </div>
        </div>
        <div class="width-0100 display-t border-b-1 border-solid border-color-b-010 margin-b-10">
            <div class="display-tc width-050 vertical-align-b padding-r-5 border-r-1 border-solid border-color-b-010">
                <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">48 hour accumulation</p>
                <p class="display-b color-b-0100 font-size-xxl text-align-r">{{ accumulation_48h }}"</p>
            </div>
            <div class="display-tc width-050 vertical-align-b padding-l-5">
                <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">7 day accumulation</p>
                <p class="display-b color-b-0100 font-size-xxl text-align-r">{{ accumulation_7d }}"</p>
            </div>
        </div>
        <div class="width-0100 display-t border-b-1 border-solid border-color-b-010">
            <div class="display-tc width-050 vertical-align-b padding-r-5 border-r-1 border-solid border-color-b-010">
                <p class="font-size-s color-b-030 font-weight-bi width-070 font-style-i">Base Depth</p>
                <p class="display-b color-b-0100 font-size-xxl text-align-r">{{ main_surface_density }}"</p>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    data () {
        return {
            accumulation_12h: '-',
            accumulation_24h: '-',
            accumulation_48h: '-',
            accumulation_7d: '-',
            main_surface_density: '-',
        }
    },
    name: 'Places',
    props: [ 'conditions' ],
    mounted () {
      this.refresh()
    },
    methods: {
        refresh() {
            this.conditions.items.forEach(idx => {
                switch (idx.duration.toLowerCase()) {
                    case 'overnight':
                    case '12 hours':
                        this.accumulation_12h = idx.amount;
                        break;
                    case "24 hours":
                        this.accumulation_24h = idx.amount;
                        break;
                    case "48 hours":
                        this.accumulation_48h = idx.amount;
                        break;
                    case "week":
                        this.accumulation_7d = idx.amount;
                        break;
                    case "base-depth":
                        this.main_surface_density = idx.amount;
                        break;
                }
            })
            // this.accumulation_12h = this.conditions.items[0].amount
            // this.accumulation_24h = this.conditions.items[1].amount
            // this.accumulation_48h = this.conditions.items[2].amount
            // this.accumulation_7d = this.conditions.items[4].amount
            // this.main_surface_density = this.conditions.items[7].amount
            // if (_.has(this.conditions.items, 'amount') && this.conditions.items[0].duration === "overnight") {
            //     this.accumulation_12h = this.conditions.items[0].amount
            // }
            // if (_.has(this.conditions.items, 'amount') && this.conditions.items[1].duration === "24 Hours") {
            //     this.accumulation_24h = this.conditions.items[1].amount
            // }
            // if (_.has(this.conditions.items, 'amount') && this.conditions.items[2].duration === "48 Hours") {
            //     this.accumulation_48h = this.conditions.items[2].amount
            // }
            // if (_.has(this.conditions.items, 'amount') && this.conditions.items[4].duration === "week") {
            //     this.accumulation_7d = this.conditions.items[4].amount
            // }
            // if (_.has(this.conditions.items, 'amount') && this.conditions.items[6].duration === "base-depth") {
            //     this.main_surface_density = this.conditions.items[6].amount
            // }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/ConditionsMulti/Place.vue